import React, { useEffect} from 'react';
import {Filter} from "../components/filter";
import {ProductsOwnToggle} from "../components/products-own-toggle";
import {rootActions, useAppDispatch, useAppSelector} from "../DAL/store";
import {Products} from "../components/products";
import {getPurchasedData} from "../../membership/purchased-products/user-purchased-products";
import {getFilteredItems, validateCurrentPromoActive} from "../services/logic-helper";
import Preloader from "../../../ui/svg/common/preloader";
import {LoginPopup} from "../components/login-popup";
import {EfsPopup} from "../components/efs-popup";
import TopButtonPortal from '../components/top-popup/top-button-portal';

/**
 * JIRA: https://wavesaudio.atlassian.net/browse/DSWEB-3089
 * OLD SITE JIRA: https://wavesaudio.atlassian.net/browse/DSWEB-407 https://dev.waves.com/sps
 */
const App: React.FC = () => {

    //const [isPageLoad, setIsPageLoad] = useState(true);

    // const filteredItems = useAppSelector(store => store.filteredItems);
    const purchased = useAppSelector(store => store.purchased);
    const hideProductsOwn = useAppSelector(store => store.hideProductsOwn);
    const PageData = useAppSelector(store => store.PageData);
    const filterTerm = useAppSelector(store => store.filterTerm);
    const showLoginPage = useAppSelector(store => store.showLoginPage);
    const showEfsPopup = useAppSelector(store => store.showEfsPopup);
    const isPageLoad = useAppSelector(store => store.isPageLoad);

    const dispatch = useAppDispatch();

    // On Page load --> set purchased data and filter items if needed
    useEffect(() => {

        (async () => {
            //query purchasedProducts only on page load & after plugin register is successful
            if(isPageLoad){
                let _purchased  = await getPurchasedData();
                let filteredItems  = getFilteredItems(hideProductsOwn,_purchased,PageData.freePlugins,filterTerm);
                dispatch(
                    rootActions.main({
                        filteredItems:filteredItems,
                        purchased:_purchased,
                        isPageLoad:false
                    })
                );
                //validates if the current promo is still active or not
                if(PageData !== null && PageData.campaignDetails !== null){
                    validateCurrentPromoActive(PageData.campaignDetails.isCampaignEnded);
                }

            }
        })();


    }, [dispatch,PageData,filterTerm,isPageLoad,purchased,hideProductsOwn]);

    return (
        <>
            <div className="waves-box-lg mx-auto px-5 md:px-12">
                {/*<div className="text-center">
                    {
                        PageData.campaignDetails.tcurl &&
                        <p className="waves-p pb-8 lg:pb-12">
                            <a href={PageData.campaignDetails.tcurl} className="" title="">See terms and conditions</a>
                        </p>
                    }
                    {
                        PageData.campaignDetails.buttonText &&
                        <div className="w-full">
                            <a href={PageData.campaignDetails.buttonURL} className="w-btn mx-auto w-fit px-8"
                               title={PageData.campaignDetails.buttonText}>{PageData.campaignDetails.buttonText}</a>
                        </div>
                    }
                </div>*/}
                {/*<div className="mt-8 lg:mt-12">

                    <ProductsOwnToggle/>
                </div>*/}

                <div className="md:border-b mb-10 pb-2 mt-8 flex justify-between items-center w-full">
                    {/*<div>Found {filteredItems.length} products</div>*/}
                    <ProductsOwnToggle/>
                    <div><Filter/></div>
                </div>

                {isPageLoad ?
                    <div className="flex items-center justify-center h-40">
                        <Preloader width={"20px"}/>
                    </div>
                    :
                    <Products/>
                }
                {showLoginPage && <LoginPopup/>}
                {showEfsPopup && <EfsPopup/>}
            </div>

            <TopButtonPortal />
        </>
    );
};

export default App;

